import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function Signup() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phoneNumber: '',
    studentId: '',
    hostelRoomNo: '',
    hostelBuildingNo: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://backend-alien.vercel.app/api/auth/createuser/', formData);

      if (!response.status === 200) {
        throw Error("Failed to Create User");
      }

      console.log(response.data); // Assuming response.data contains the user data

      // Storing response data in localStorage
      localStorage.setItem("userData", JSON.stringify(response.data));

      toast.success('User registered successfully!');
      navigate('/home');
    } catch (error) {
      toast.error(error.message);
      console.error('Error registering user:', error.message);
    }
  };
  return (
    <div>
        <div className="bg-white py-8 px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-center">
      <div className="md:w-1/2 max-w-md mr-8 rounded-lg overflow-hidden shadow-lg">
        <div className="text-center px-6 py-4">
          <h2 className="text-xl font-semibold text-gray-900">Register</h2>
          <p className="mt-2 text-sm text-gray-600">Create your account</p>
        </div>
        <form className="px-6 pt-4 pb-8" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="name" className="sr-only">Name</label>
              <input onChange={handleChange} id="name" name="name" type="text" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Name" />
            </div>
            <div>
              <label htmlFor="email" className="sr-only">Email</label>
              <input onChange={handleChange} id="email" name="email" type="email" autoComplete="email" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Email" />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">Password</label>
              <input onChange={handleChange} id="password" name="password" type="password" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Password" />
            </div>
            <div>
              <label htmlFor="studentId" className="sr-only">Student ID</label>
              <input onChange={handleChange} id="studentId" name="studentId" type="text" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="6 Digit Student ID" />
            </div>
            <div>
              <label htmlFor="phoneNumber" className="sr-only">Phone Number</label>
              <input onChange={handleChange} id="phoneNumber" name="phoneNumber" type="text" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Phone Number" />
            </div>
            <div>
              <label htmlFor="hostelRoomNo" className="sr-only">Hostel Room No</label>
              <input onChange={handleChange} id="hostelRoomNo" name="hostelRoomNo" type="text" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Hostel Room No" />
            </div>
            <div>
              <label htmlFor="hostelBuildingNo" className="sr-only">Hostel Building No</label>
              <input onChange={handleChange} id="hostelBuildingNo" name="hostelBuildingNo" type="text" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Hostel Building No" />
            </div>
          </div>
          <div className="mt-6">
            <button type="submit" className="w-full px-4 py-2 rounded-md bg-indigo-600 text-white font-semibold focus:outline-none focus:bg-indigo-700 hover:bg-indigo-700">Register</button>
          </div>
        </form>
      </div>
      <div className="md:w-1/2">
        <img src="https://static.vecteezy.com/system/resources/previews/005/879/539/non_2x/cloud-computing-modern-flat-concept-for-web-banner-design-man-enters-password-and-login-to-access-cloud-storage-for-uploading-and-processing-files-illustration-with-isolated-people-scene-free-vector.jpg" alt="Sample" className="w-full h-full object-cover" />
      </div>
    </div>
    </div>
  )
}
